import { render, staticRenderFns } from "./W0106V0001.vue?vue&type=template&id=27ff57f8&scoped=true&"
import script from "./W0106V0001.vue?vue&type=script&lang=js&"
export * from "./W0106V0001.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ff57f8",
  null
  
)

export default component.exports